module.exports = __webpack_public_path__ + "img/chart_bar.a8635dd2.webp";